import { MyCommonService } from "./my-common.service";
import { NavigationEnd, Router } from "@angular/router";
import {Injectable, Inject, PLATFORM_ID} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.prod";
import { map, filter } from "rxjs/operators";
import { GlobalServiceService } from './global-service.service';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: "root"
})

export class DentistProfileService {
  // https://blog.dentalchat.com/server/service/dentistservice/update-dentist-profile-step1
  // https://blog.dentalchat.com/server/service/dentistservice/update-dentist-profile-step2
  // https://blog.dentalchat.com/server/service/dentistservice/update-dentist-profile-step3
  // https://blog.dentalchat.com/server/service/dentistservice/update-dentist-profile-step4
  // https://blog.dentalchat.com/server/service/dentistservice/update-dentist-profile-step5
  // https://blog.dentalchat.com/server/service/dentistservice/update-dentist-profile-step6
  // https://blog.dentalchat.com/server/service/dentistservice/update-dentist-profile-step7
  // https://blog.dentalchat.com/server/service/dentistservice/remove-award
  // https://blog.dentalchat.com/server/service/dentistservice/remove-certificate
  // https://blog.dentalchat.com/server/service/dentistservice/remove-insurance
  // https://blog.dentalchat.com/server/service/dentistservice/remove-education
  // https://blog.dentalchat.com/server/service/dentistservice/remove-license
  // https://blog.dentalchat.com/server/service/dentistservice/remove-license-image
  // https://blog.dentalchat.com/server/service/dentistservice/remove-experience
  // https://blog.dentalchat.com/server/service/dentistservice/remove-experience-image
  // https://blog.dentalchat.com/server/service/dentistservice/remove-skill
  // https://blog.dentalchat.com/server/service/dentistservice/save-show-preview
  // https://blog.dentalchat.com/server/service/dentistservice/change-password
  // https://blog.dentalchat.com/server/service/dentistservice/dentist-profile
  // https://blog.dentalchat.com/server/service/dentistservice/dentist-preview
  // https://blog.dentalchat.com/server/service/dentistservice/dentist-publish
  // https://blog.dentalchat.com/server/service/register
  // https://blog.dentalchat.com/server/service/check-activation
  // https://blog.dentalchat.com/server/service/dentist-login
  // https://blog.dentalchat.com/server/service/forgot-password
  // https://blog.dentalchat.com/server/service/check-link
  // https://blog.dentalchat.com/server/service/change-forgot-password

  config;

  config2 = {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  };
    private localStorage: Storage = {
    getItem: () => "",
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
    length: 0,
    key: () => null,
  } satisfies Storage;
  private window: Window;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private myCommonService: MyCommonService,
    private router: Router,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.window = window;
      this.localStorage = window.localStorage;
    }
    this.config = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Token": this.localStorage?.getItem('access_token')
      }
    };
  }

  // getToken(){
  //   return this.common.access_token.subscribe(data => {
  //     return data;
  //   })
  // }

  registerDentist(data) {
    return this.http.post(
      `${environment.apiURL}/service/register`,
      data,
      this.config2
    );
  }

  changeForgotPassword(data) {
    return this.http.post(
      `${environment.apiURL}/service/change-forgot-password`,
      data,
      this.config2
    );
  }

  /*******************Vikas************************/
  sendChatbotScript(data) {
    return this.http.post(
      `${environment.apiURL}/send-chatbot-script`,
      data,
      this.config2
    );
  }
  dentistResetPassword(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/change-forgot-password`,
      data,
      config
    );
  }
  cancelSubscriptionPlan(data) {
    return this.http.post(
      `${environment.apiURL}/cancel-subscribe-plan`,
      data,
      this.config2
    );
  }
  saveChatbotWelcomeSetting(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/save-chatbot-welcome-setting`,
      data,
      this.config2
    );
  }
  getSmartBotSetting(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/smart-bot-setting`,
      data,
      this.config2
    );
  }
  saveSmsDetail(data) {
    return this.http.post(
      `${environment.apiURL}/save-sms-integration-setting`,
      data,
      this.config2
    );
  }
  dentistPhoneVerification(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-phone-verification`,
      data,
      this.config2
    );
  }
  dentistOtpVerification(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-otp-verification`,
      data,
      this.config2
    );
  }
  requestForAddPatient(data) {
    return this.http.post(
      `${environment.apiURL}/add-my-patient`,
      data,
      this.config2
    );
  }
  archivePost(data) {
    return this.http.post(
      `${environment.apiURL}/archive-post`,
      data,
      this.config2
    );
  }
  requestForRemovePatient(data) {
    return this.http.post(
      `${environment.apiURL}/remove-my-patient`,
      data,
      this.config2
    );
  }
  /*requestForFetchMyPatient(data) {
    return this.http.post(
      `${environment.apiURL}/fetch-dentist-patient`,
      data,
      this.config2
    );
  }*/
  requestForFetchMyPatient(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-fetch-dentist-patient`,
      data,
      this.config2
    );
  }
  requestForFetchMyClinic(data) {
    return this.http.post(
      `${environment.apiURL}/fetch-myclinic-post`,
      data,
      this.config2
    );
  }
  requestForFetchMyPayment(data) {
    return this.http.post(
      `${environment.apiURL}/fetch-mypayment`,
      data,
      this.config2
    );
  }
  requestForStartVideo(data) {
    return this.http.post(
      `${environment.apiURL}/create-video-meeting`,
      data,
      this.config2
    );
  }
  requestForStartVideoOnTeleDental(data) {
    return this.http.post(
      `${environment.apiUrlTeleDental}/createMeeting`,
      data,
      this.config2
    );
  }
  requestForGetMeetingRoom(data) {
    return this.http.post(
      `${environment.apiURL}/get-meeting-room`,
      data,
      this.config2
    );
  }
  cancelVideoConsultationRequest(data) {
    return this.http.post(
      `${environment.apiURL}/cancel-video-consultation-request`,
      data,
      this.config2
    );
  }
  removeVideoConsultationRequest(data) {
    return this.http.post(
      `${environment.apiURL}/remove-video-consultation-request`,
      data,
      this.config2
    );
  }
  completeVideoConsultation(data) {
    return this.http.post(
      `${environment.apiURL}/complete-video-consultation`,
      data,
      this.config2
    );
  }
  requestForPrescription(data) {
    return this.http.post(
      `${environment.apiURL}/get-prescription`,
      data,
      this.config2
    );
  }
  requestForMedicalForm(data) {
    return this.http.post(
      `${environment.apiURL}/request-medical-form`,
      data,
      this.config2
    );
  }
  meetingRoomLicenseRequest(data) {
    return this.http.post(
      `${environment.apiURL}/meeting-room-license-request`,
      data,
      this.config2
    );
  }
  closeMeetingRoom(data) {
    return this.http.post(
      `${environment.apiURL}/close-meeting-room`,
      data,
      this.config2
    );
  }
  checkMeetingRoomExist(data) {
    return this.http.post(
      `${environment.apiURL}/check-meeting-room-exist`,
      data,
      this.config2
    );
  }
  smartBotLicenseRequest(data) {
    return this.http.post(
      `${environment.apiURL}/smart-bot-license-request`,
      data,
      this.config2
    );
  }
  checkMeetingRoomSecretCode(data) {
    return this.http.post(
      `${environment.apiURL}/check-meeting-room-secret-code`,
      data,
      this.config2
    );
  }
  saveVideoNotes(data) {
    return this.http.post(
      `${environment.apiURL}/save-video-notes`,
      data,
      this.config2
    );
  }
  saveDentistPMSNotes(data) {
    return this.http.post(
      `${environment.apiURL}/save-dentist-pms-notes`,
      data,
      this.config2
    );
  }
  saveSikkaNotes(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-medical-note`,
      data,
      this.config2
    );
  }
  sendPatientInvitation(data) {
    return this.http.post(
      `${environment.apiURL}/send-patient-invitation`,
      data,
      this.config2
    );
  }
  sendPatientPost(data) {
    return this.http.post(
      `${environment.apiURL}/send-patient-post`,
      data,
      this.config2
    );
  }
  requestForMeetingRoomNotes(data) {
    return this.http.post(
      `${environment.apiURL}/meeting-room-notes`,
      data,
      this.config2
    );
  }
  getPatientDetails(data) {
    return this.http.post(
      `${environment.apiURL}/get-patient-details`,
      data,
      this.config2
    );
  }
  appointmentCheck(data) {
    return this.http.post(
      `${environment.apiURL}/appointment-list`,
      data,
      this.config2
    );
  }
  openDentalDentistList(data) {
    return this.http.post(
      `${environment.apiURL}/open-dental-dentist-list`,
      data,
      this.config2
    );
  }
  getOpenDentalAppointment(data) {
    return this.http.post(
      `${environment.apiURL}/get-open-dental-appointment`,
      data,
      this.config2
    );
  }
  /*insertPatientInopenDental(data,patient_id) {
    return this.http.post(
      `${environment.apiURL}/insert-external-patient`,
      data,
      patient_id
    );
  }*/
  insertPatientInopenDental(data,patient_id) {
    return this.http.post(
      `${environment.apiURL}/sikka-patient-create`,
      data,
      patient_id
    );
  }
  lookupInopneDental(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-search-patient`,
      data,
      this.config2
    );
  }
  addPatientInDentalchat(data) {
    return this.http.post(
      `${environment.apiURL}/add-patient-in-dentalchat`,
      data,
      this.config2
    );
  }

  /*addOpenPatient(data) {
    return this.http.post(
      `${environment.apiURL}/add-open-patient`,
      data,
      this.config2
    );
  }*/

  addOpenPatient(data) {
    return this.http.post(
      `${environment.apiURL}/add-sikka-patient`,
      data,
      this.config2
    );
  }

  getInvitePatientList(data) {
    return this.http.post(
      `${environment.apiURL}/get-invite-patient-list`,
      data,
      this.config2
    );
  }
  getServiceList(data) {
    return this.http.post(
      `${environment.apiURL}/get-service`,
      data,
      this.config2
    );
  }
  getServiceListData(data) {
    return this.http.post(
      `${environment.apiURL}/get-service-list`,
      data,
      this.config2
    );
  }
  sendMessgeToAgent(data) {
    return this.http.post(
      `${environment.apiURL}/send-message-to-agent`,
      data,
      this.config2
    );
  }
  referralInviteDentist(data) {
    return this.http.post(
      `${environment.apiURL}/referral-invite-dentist`,
      data,
      this.config2
    );
  }
  updatePMSInfo(data) {
    return this.http.post(
      `${environment.apiURL}/update-pms-info`,
      data,
      this.config2
    );
  }
  getPMSInfo(data) {
    return this.http.post(
      `${environment.apiURL}/get-pms-info`,
      data,
      this.config2
    );
  }
  requestOnlineDemo(data) {
    return this.http.post(
      `${environment.apiURL}/request-online-demo`,
      data,
      this.config2
    );
  }
  updateSmartLeadCategory(data) {
    return this.http.post(
      `${environment.apiURL}/update-smart-lead-category`,
      data,
      this.config2
    );
  }
  checkChatbotAccessToken(data) {
    return this.http.post(
      `${environment.apiURL}/check-chatbot-access-token`,
      data,
      this.config2
    );
  }
  switchDentistToAgent(data) {
    return this.http.post(
      `${environment.apiURL}/switch-dentist-to-agent`,
      data,
      this.config2
    );
  }
  switchAgentToDentist(data) {
    return this.http.post(
      `${environment.apiURL}/switch-agent-to-dentist`,
      data,
      this.config2
    );
  }
  /*******************Vikas************************/

  checkLink(data) {
    return this.http.post(
      `${environment.apiURL}/service/check-link`,
      data,
      this.config2
    );
  }

  forgotPassword(data) {
    return this.http.post(
      `${environment.apiURL}/service/forgot-password`,
      data,
      this.config2
    );
  }

  dentistLogin(data) {
    if (data.user)
      data.user.skip_doctor_review = "1";
    return this.http.post(
      `${environment.apiURL}/service/dentist-login`,
      data,
      this.config2
    );
  }

  checkActivation(data) {
    return this.http.post(
      `${environment.apiURL}/service/check-activation`,
      data,
      this.config2
    );
  }

  register(data) {

    return this.http.post(
      `${environment.apiURL}/service/register`,
      data,
      this.config2
    );
  }

  dentistPublish(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-publish`,
      data,
      this.config
    );
  }

  dentistProfile(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-profile`,
      data,
      this.config
    );
  }

  dentistPreview(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-preview`,
      data
    );
  }

  changePassword(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/change-password`,
      data
    );
  }

  saveShowProfile(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/save-show-preview`,
      data, config
    );
  }

  removeSkill(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-skill`,
      data,
      this.config
    );
  }

  removeExperienceImage(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-experience-image`,
      data,
      this.config
    );
  }

  removeExperience(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-experience`,
      data,
      this.config
    );
  }

  removeLicenseImage(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-license-image`,
      data,
      this.config
    );
  }
  removeLicense(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-license`,
      data,
      this.config
    );
  }

  removeEducation(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-education`,
      data,
      this.config
    );
  }

  removeInsurance(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-insurance`,
      data,
      this.config
    );
  }

  removeCertificate(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-certificate`,
      data,
      this.config
    );
  }

  removeAward(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/remove-award`,
      data,
      this.config
    );
  }

  updateDentistProfileStep1(data) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step1`,
      data,
      {}
    );
  }

  updateDentistProfileStep2(data, config) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step2`,
      data,
      config
    );
  }

  updateDentistProfileStep3(data, config) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step3`,
      data,
      config
    );
  }

  updateDentistProfileStep4(data, config) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step4`,
      data,
      config
    );
  }

  updateDentistProfileStep5(data, config) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step5`,
      data,
      config
    );
  }

  updateDentistProfileStep6(data, config) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step6`,
      data,
      config
    );
  }

  updateDentistProfileStep7(data, config) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step7`,
      data,
      config
    );
  }
  updateDentistProfileStep8(data) {
    return this.http.post(
      `${
        environment.apiURL
      }/service/dentistservice/update-dentist-profile-step8`,
      data
    );
  }

  changePeriodcharts(data) {
    return this.http.post(
      `${environment.apiURL}/get-barcharts-data`,
      data,
      this.config2
    );
  }

  upgradePlan(data) {
    return this.http.post(
      `${environment.apiURL}/upgrade-plan`,
      data,
      this.config2
    );
  }
  updateWebsite(data) {
    return this.http.post(
      `${environment.apiURL}/web-url-update`,
      data,
      this.config2
    );
  }
  readChatDentist(data) {
    return this.http.post(
      `${environment.apiURL}/read-chat-dentist`,
      data,
      this.config
    );
  }
  imageUploaded(data) {
    return this.http.post(
      `${environment.chatImageuploadApiPath}/image-uploaded`,
      data
    );
  }
  saveChatHistory(data) {
    return this.http.post(
      `${environment.apiURL}/save-chat-history`,
      data,
      this.config
    );
  }
  dentistPopup(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-popup`,
      data,
      this.config2
    );
  }
  setAppointmetDoctors(data) {
    return this.http.post(
      `${environment.apiURL}/set-appointment-doctors`,
      data,
      this.config
    );
  }
  checkLastServieCallTimeAfterLogin() {
    return this.http.get(
      `${environment.apiURL}/service/check-last-servie-call-time-after-login`,
      this.config
    );
  }

  _scrollToTop() {
    if (this.myCommonService.isBrowser) {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          this.window.scrollTo(0, 0);
        });
    }
  }

  DentistQuestions(data) {
    return this.http.post(
      `${environment.apiURL}/service/cms/submit-question`,
      data,
      this.config
    );
  }

  DentistPrice(data) {
    return this.http.post(
      `${environment.apiURL}/service/cms/submit-price`,
      data,
      this.config2
    );
  }

  getDentistProfileStep1(data) {
    return this.http.post(
      `${environment.apiURL}/dentistservice/dentist-step1`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep2(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step2`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep3(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step3`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep4(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step4`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }
  getDentistProfileStep5(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step5`,
      data,
      this.config
    );
  }
  getDentistProfileStep6(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step6`,
      data,
      this.config
    );
  }
  getDentistProfileStep7(data) {
    return this.http.post(
      `${environment.apiURL}/service/dentistservice/dentist-step7`,
      data,
      this.config
    ).pipe(
      map(res =>{
        return res;
      })
    );
  }

  /******************Rahul***********************/
  getLostMessages(data) {
    return this.http.post(
      `${environment.apiURL}/get-lost-messages`,
      data
    );
  }

  updatePatientPost(data) {
    return this.http.post(
      `${environment.apiURL}/update-patient-post`,
      data
    );
  }

  PatientLogout(data, config) {
    return this.http.post(
      `${environment.apiURL}/patient-logout`,
      data,
      config
    );
  }

  DentistLogout(data, config) {
    return this.http.post(
      `${environment.apiURL}/service/logout`,
      data,
      config
    );
  }

  adddentist(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-add-office-staff`,
      data
    );
  }
  getentist(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-list-office-staff`,
      data
    );
  }

  getSingleOfficeStaff(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-get-single-office-staff
`,
      data
    );
  }

  updateDentist(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-edit-office-staff`,
      data
    );
  }
  deleteDentist(data) {
    return this.http.post(
      `${environment.apiURL}/dentist-delete-office-staff`,
      data
    );
  }
  getDentistInfo(data) {
    return this.http.post(
      `${environment.apiURL}/get-dentist-info`,
      data
    );
  }
  /******************Rahul***********************/

  //Neeraj Masih
  requestsikkaAppointmentStatuses(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-appointment-statuses`,
      data
    );
  }
  requestCheckForPMSinfo(data) {
    return this.http.post(
      `${environment.apiURL}/check-pms-info`,
      data
    );
  }
  requestSikkaOperatory(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-get-operatory`,
      data
    );
  }
  makeAppointment(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-make-appointment`,
      data
    );
  }
  patientInsertIntoPMS(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-patient-insert-into-pms`,
      data
    );
  }
  sikkaPatientApointmentCreate(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-patient-apointment-create`,
      data
    );
  }

  sikkaPatientPmsId(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-patient-pms-id`,
      data
    );
  }

  SikkaCreatePost(data) {
    return this.http.post(
      `${environment.apiURL}/sikka-create-patient-post`,
      data
    );
  }

  sikkaSetAppointment(data) {
    return this.http.post(
      `${environment.apiURL}/set-appointment-doctors`,
      data
    );
  }
  sikkaSaveChat(data) {
    return this.http.post(
      `${environment.apiURL}/save-chat-history`,
      data
    );
  }
  sikkaLostMessage(data) {
    return this.http.post(
      `${environment.apiURL}/get-lost-messages`,
      data
    );
  }
  sikkaRefreshChat(data) {
    return this.http.post(
      `${environment.apiURL}/read-chat-dentist`,
      data
    );
  }

}
